import {  useRef } from "react";

import { gsap} from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

import "./BrandSection.scss";

import eoneLogo from "../../Assets/Brands/lionsgate.svg";
import lionsgateLogo from "../../Assets/Brands/eone.svg";
import maverikLogo from "../../Assets/Brands/maverik.svg";
import amdLogo from "../../Assets/Brands/amd.svg";
import marathonSportsLogo from "../../Assets/Brands/marathon-sports.svg";
import nikeLogo from "../../Assets/Brands/nike.svg";

gsap.registerPlugin(ScrollTrigger);

const BrandSection = () => {

  const brandLogos = useRef(null);

  // useEffect(() => {
  //   var drawLine = gsap.timeline({});

  //   drawLine.to(bgReveal.current, {
  //     scrollTrigger: {
  //       trigger: bgReveal.current,
  //       // start: 'center 80vh',
  //       // end: 'bottom 20vh',
  //       // markers: true,
  //       // scrub: true,
  //     },
  //     ease: Power3.easeInOut,
  //     duration: 1,
  //     // scaleX: '0',
  //     scaleX: "90%",
  //     transformOrigin: "left center",
  //     //  scale: 2,
  //   });

  //   drawLine.to(bgReveal.current.children, {
  //     scrollTrigger: {
  //       trigger: bgReveal.current,
  //       // start: '100% 80vh',
  //       // markers: true,
  //       // scrub: true,
  //     },
  //     ease: Power3.easeInOut,
  //     duration: 0.5,
  //     height: "100%",
  //     transformOrigin: "left center",
  //   });

  //   drawLine.fromTo(
  //     brandLogos.current.children,
  //     {
  //       opacity: 0,
  //       scaleX: 0,
  //     },
  //     {
  //       scrollTrigger: {
  //         trigger: bgReveal.current,
  //       },
  //       stagger: {
  //         each: 0.2,
  //         from: "left",
  //       },
  //       delay: -0.5,
  //       ease: Power3.easeInOut,
  //       duration: 0.5,
  //       opacity: 1,
  //       scaleX: 1,
  //       // transformOrigin: 'bottom bottom',
  //     }
  //   );
  // }, []);

  return (
    <div className="brand-section">
      {/* <div className="bg-reveal" ref={bgReveal}>
        <div className="left-border"></div>
      </div> */}
      <div className="section-description">
        <p>
          
          <span className="highlighted">
            {/* <span className="blur-decoration-large" /> */}
            WELL-KNOWN
          </span>{" "}
          BRANDS
          <br /> HAD CHANCE TO BE WORKING 
        </p>
        <span className="watermark">Brands</span>
      </div>

      <div className="brand-logos" ref={brandLogos}>
        <div className="logo-item">
          <img src={eoneLogo} alt="eone" />
        </div>
        <div className="logo-item">
          <img src={lionsgateLogo} alt="lionsgate" />
        </div>
        <div className="logo-item">
          <img src={maverikLogo} alt="maverikLogo" />
        </div>
        <div className="logo-item">
          <img src={amdLogo} alt="amdLogo" />
        </div>
        <div className="logo-item">
          <img src={marathonSportsLogo} alt="marathonSportsLogo" />
        </div>
        <div className="logo-item">
          <img src={nikeLogo} alt="nikeLogo" />
        </div>
      </div>
    </div>
  );
};

export default BrandSection;
